import { ComponentChildren } from 'preact';

interface IShowProps<T> {
	when: T | undefined | null | boolean;
	fallback?: ComponentChildren;
	children: ComponentChildren;
}

const Show = <T,>({
	when,
	fallback = null,
	children,
}: IShowProps<T>): ComponentChildren => (when ? children : fallback);

export default Show;
